// src/utils/reviewStats.js

/**
 * Calculate average review stats from feedback array
 */
export const calculateFeedbackStats = (feedbacks = []) => {
  if (!feedbacks.length) return null;
  const count = feedbacks.length;
  const sums = feedbacks.reduce(
    (acc, f) => {
      acc.cleanliness += f.cleanliness;
      acc.location += f.location;
      acc.value += f.value;
      acc.comfort += f.comfort;
      return acc;
    },
    { cleanliness: 0, location: 0, value: 0, comfort: 0 }
  );
  const averages = {
    cleanliness: sums.cleanliness / count,
    location: sums.location / count,
    value: sums.value / count,
    comfort: sums.comfort / count,
  };
  const overallAverage = (averages.cleanliness + averages.location + averages.value + averages.comfort) / 4;
  return {
    average: Number(overallAverage.toFixed(1)),
    count,
    perCategory: averages,
    source: "Verified Guests",
  };
};

/**
 * Emoji based on rating
 */
export const ratingEmoji = (value) => {
  if (value >= 9) return "🤩";
  if (value >= 8) return "😍";
  if (value >= 7) return "😊";
  if (value >= 6) return "🙂";
  if (value >= 5) return "😐";
  if (value >= 4) return "😕";
  return "😞";
};

